import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { BookOpen } from "lucide-react";
import type { ChatSource } from "@/types/chat";

interface SourcesAccordionProps {
  sources: ChatSource[];
}

export function SourcesAccordion({ sources }: SourcesAccordionProps) {
  if (!sources || sources.length === 0) return null;

  return (
    <Accordion type="single" collapsible className="w-full max-w-lg">
      <AccordionItem value="sources" className="border-none">
        <AccordionTrigger className="py-1 px-2 text-xs text-muted-foreground hover:no-underline">
          <span className="flex items-center gap-1">
            <BookOpen className="w-3 h-3" />
            {sources.length} source{sources.length !== 1 ? "s" : ""}
          </span>
        </AccordionTrigger>
        <AccordionContent className="pb-1">
          <div className="space-y-2">
            {sources.map((source, i) => (
              <div
                key={i}
                className="rounded-lg border bg-background p-2.5 text-xs"
              >
                <div className="flex items-center gap-2 mb-1.5">
                  <Badge variant="secondary" className="text-[10px] px-1.5 py-0">
                    #{i + 1}
                  </Badge>
                  {source.similarity !== null && (
                    <Badge
                      variant="outline"
                      className="text-[10px] px-1.5 py-0"
                    >
                      {(source.similarity * 100).toFixed(0)}% match
                    </Badge>
                  )}
                  <Badge
                    variant="outline"
                    className="text-[10px] px-1.5 py-0"
                  >
                    score: {source.score.toFixed(3)}
                  </Badge>
                </div>
                <p className="text-muted-foreground line-clamp-4 leading-relaxed">
                  {source.chunkText}
                </p>
              </div>
            ))}
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
